import orderBy from "lodash.orderby";
// Fluent UI
import { DefaultPalette } from "@fluentui/react";

// gets and sort menus
export function getNavMenuGroups(modules, identifier) {
  if (!modules.length) return [];
  const module = modules.find(module => module.identifier === identifier);
  try {
    let newNavMenuGroups = [];
    module.menus.forEach(menu => {
      const link = {
        name: menu.menuTitle,
        url: module.link + menu.endpoint,
        key: menu.endpoint.replace("/", ""),
        icon: menu.iconName,
        sort: menu.sortOrder
      };
      newNavMenuGroups = [...newNavMenuGroups, link];
    });
    return [{ links: orderBy(newNavMenuGroups, ["sort"]) }];
  } catch (ev) {
    return [];
  }
}

// gets IconProps for files
export function getFileIconProps(type) {
  switch (type) {
    case "CSV":
      return {
        iconName: "TextDocument",
        color: "#7a7574"
      };
    case "XLSX":
      return {
        iconName: "ExcelDocument",
        color: "#217346"
      };
    case "HTML":
      return {
        iconName: "ReportDocument",
        color: "#a4262c"
      };
    default:
      return {
        iconName: "BIDashboard",
        color: DefaultPalette.themePrimary
      };
  }
}
